import { render, staticRenderFns } from "./BookableItems.vue?vue&type=template&id=1d3fb106&scoped=true&"
import script from "./BookableItems.vue?vue&type=script&lang=js&"
export * from "./BookableItems.vue?vue&type=script&lang=js&"
import style0 from "./BookableItems.vue?vue&type=style&index=0&id=1d3fb106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3fb106",
  null
  
)

export default component.exports